import { defineStore } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';
import type {
  IncomeReportData,
  IncomeReportDeliveryType,
} from '@/types/incomeReport';

export const useIncomeReportStore = defineStore(
  'incomeReport',
  () => {
    const currentReport = ref<IncomeReportData | null>(null);
    const isGenerating = ref<boolean>(false);
    const isPolling = ref<boolean>(false);
    const pollingIntervalId = ref<NodeJS.Timeout | null>(null);
    const error = ref<string | null>(null);
    const allowedTypes = ref<IncomeReportDeliveryType[]>(['download', 'email']);

    function setCurrentReport(data: IncomeReportData | null) {
      currentReport.value = data;
    }

    function setGenerating(status: boolean) {
      isGenerating.value = status;
    }

    function setPolling(status: boolean) {
      isPolling.value = status;
    }

    function setPollingIntervalId(id: NodeJS.Timeout | null) {
      pollingIntervalId.value = id;
    }

    function setError(message: string | null) {
      error.value = message;
    }

    function setAllowedTypes(types: IncomeReportDeliveryType[]) {
      allowedTypes.value = types;
    }

    function resetReport() {
      currentReport.value = null;
      error.value = null;
    }

    function $reset() {
      currentReport.value = null;
      isGenerating.value = false;
      isPolling.value = false;
      pollingIntervalId.value = null;
      error.value = null;
      allowedTypes.value = ['download', 'email'];
    }

    return {
      currentReport,
      isGenerating,
      isPolling,
      pollingIntervalId,
      error,
      allowedTypes,
      setCurrentReport,
      setGenerating,
      setPolling,
      setPollingIntervalId,
      setError,
      setAllowedTypes,
      resetReport,
      $reset,
    };
  },
  storeConfig,
);
